module.exports = __webpack_public_path__ + "static/media/JAPAN-Kyoto.dc25b000.png";